var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"min-height":"100%"}},[_c('StandardHeader'),_c('div',{staticStyle:{"min-height":"100%","position":"relative"}},[_c('v-card',{staticStyle:{"max-width":"90vw","max-height":"38vh","position":"absolute","top":"-50px","bottom":"50px","right":"0","left":"0","margin":"auto"},attrs:{"elevation":"0"}},[_c('LoginCard')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }